<template>
    <div>
        <div class='campus-bg'>
            <el-image :src="campus_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <el-image :src="campus_title" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class='home_content'>
                <div class='home_title'>
                    <img src="../assets/home/home_title_icon.png"  style="height: 4.5vw;">
                    <p>{{$t('home.bole_we')}}</p>
                </div>
                <div class="video_content">
                    <div class="video">
                        <video v-if="is_mobile_video" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/job_video.mp4" preload="none"
                               controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_2.jpg"> </video>
                        <video v-else src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/job_video.mp4"  preload="none"
                               controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_2.jpg"> </video>
                    </div>
                </div>
            </div>
            <div class='campus-list'>
                <div class="campus-item">
                    <el-image :src="campus_welfare" class="campus-img"></el-image>
                </div>
                <div class="campus-item-job">
                    <el-image :src="social_job_bg" class="campus-img"></el-image>
                    <el-row :gutter="0" class="job-row">
                        <el-col v-for="job in job_list" :span="6" :key="job.name" class="jon-el-col">
                            <router-link :to="'/join_campus_details?job_name='+job.name" style="position:relative;">
<!--                                <el-image :src="'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/'+ job.name +'.png'" style="margin: 4% 0; position: relative;">-->
<!--                                </el-image>-->
<!--                                <img :src="'./assets/resource_10_23/' + job.name + '.jpg'" class="job-col-img" alt="">-->
                                <el-image :src="job.img" class="job-col-img" alt=""></el-image>
                            </router-link>
                        </el-col>
                    </el-row>
                </div>
                <div class="campus-item">
                    <el-image :src="campus_up" class="campus-img"></el-image>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            campus_header: '',
            campus_title: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_title.png',
            // campus_welfare: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_welfare.png',
            campus_welfare: '',
            social_job_bg: '',
            campus_up: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_up.png',
            job_list: [],
        }
    },
    created() {
        this.getJson();
    },
    methods: {
        getJson() {
            const json = require('../assets/json/new_campus_job.json');
            const data = Object.keys(json);
            this.job_list = data.map((item) => {
                return {
                    name: item,
                    img: `${require('../assets/resource_10_23/' + item + '.jpg')}`,
                };
            })
        }
    },
    computed: {
      //是否使用移动端视频
      is_mobile_video() {
        return document.documentElement.clientWidth > 992;
      },
    },
}
</script>

<style>

.campus-item, .campus-item-job {
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.campus-item {
    width: 90%;
}
.campus-item-job {
    width: 60%;
    position: relative;
}
.campus-img{
    width: 100%;
}
.job-row {
    margin-top: 15%;
    position: absolute;
    left: 0px;
    top: 0px;
}
.jon-el-col {
    position: relative;
}
.job-col-img {
    margin: 4% 0;
    position: relative;
    width: 80%;
}
@media screen and (max-width: 992px) {
    .campus-item {
        width: 120%;
        position: relative;
        right: 10%;
    }
    .campus-item, .campus-item-job {
        margin-top: 20px;
    }
    .campus-item-job {
        width: 80%;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/JoinUsCampus.vue